import $ from 'jquery';

function govBanner() {
  var $header_breadcrumbs = $('.breadcrumbs');
  //if no banner, navbar needs to move to the top
  const divWithClassExists = document.querySelectorAll(
    'div.header_banner_container'
  ).length > 0;
  if ($("body").hasClass("dnnEditState header-banner-is-open")) {
    $header_breadcrumbs.addClass('officialBannerOpenEdit');
  }
  if (!divWithClassExists) {
    $header_breadcrumbs.addClass('no-officialBanner');
  }
  else {
    $header_breadcrumbs.addClass('officialBanner');
  }
  for (var el = document.getElementsByClassName("header_banner_accordion"),
    t = document.getElementsByClassName("header_banner_container"),
    i = 0; i < el.length; i++)
    el[i].addEventListener("click",
      function () {
        if (($("body").hasClass("hide-afpims")) || !($("body").hasClass("dnnEditState"))) {
          $header_breadcrumbs.toggleClass('officialBannerOpen');
        }
        if (!($("body").hasClass("header-banner-is-open"))) {
          if (!divWithClassExists) {
            $header_breadcrumbs.addClass('no-officialBanner');
          }
          else {
            $header_breadcrumbs.addClass('officialBanner');
          }
        }
      });
}
  
export default govBanner;
